<div class="modal-header">
    <span *ngIf="!tagId" class="modal-header-title">{{ 'DIALOG.TAG_LIST.ADD_MARK' | translate }}</span>
    <span *ngIf="tagId"  class="modal-header-title">{{ 'DIALOG.TAG_LIST.EDIT_MARK' | translate }}</span>
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <span aria-hidden="true"><i class="bi bi-x-lg" style="font-size: 16px;"></i></span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12 tag-name">

                <label class="label"> 
                    Наименование метки
                    <svg-icon class="" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon>
                </label>
                <ff-input-lang
                    placeHolder="Укажите название значения на всех языках"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="tagName"
                    (changeValue)="eventFnFF('name', $event)">
                </ff-input-lang>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label class="label" for="tags_graphical_primitives"> Иконка метки</label>
                    <ng-select 
                    id="tags_graphical_primitives" 
                    class="custom" 
                    clearAllText="{{ 'CLEAN' | translate }}"
                    notFoundText="{{ 'NO_DATA' | translate }}" 
                    bindLabel="name" 
                    bindValue="id"
                    formControlName="graphic_primitive_id" 
                    [multiple]="false" 
                    [items]="graphicalPrimitives">
                    </ng-select>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label class="label" for="tag_size_detail_id"> {{ 'DIALOG.TAG_LIST.MARK_SIZE' | translate }} </label>
                    <ng-select 
                    id="tag_size_detail_id" 
                    class="custom" 
                    clearAllText="{{ 'CLEAN' | translate }}"
                    notFoundText="{{ 'NO_DATA' | translate }}" 
                    bindLabel="name" 
                    bindValue="id"
                    formControlName="tag_size_detail_id" 
                    [multiple]="false" 
                    [items]="sizeDetails">
                    </ng-select>
                </div>
            </div>

            <div class="col-6 form-group color-block-choose">
                <label class="label" for="color-block">Выберите цвет иконки </label>
                <input class="color-block" [(colorPicker)]="tagColor" [style.background]="tagColor" [cpOKButton]="true"/>
            </div>

            <div class="col-6 form-group color-block-choose">
                <label class="label" for="color-block">{{ 'DIALOG.TAG_LIST.CHOOSE_COLOR_TEXT' | translate }} </label>
                <input class="color-block" [(colorPicker)]="tagTextColor" [style.background]="tagTextColor" [cpOKButton]="true"/>
            </div>
            
            <div class="col-6 form-group checkbox-block">
                <label class="label" for="form-check-input"> {{ 'DIALOG.TAG_LIST.DISPLAY_FIGURE_MARK' | translate }}?</label>
                <div class="checkbox">
                    <!-- <input type="checkbox" formControlName="graphics_visible"> -->
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" name="graphics_visible"
                            id="graphics_visible" formControlName="graphics_visible">
                        <label class="custom-control-label" for="graphics_visible"></label>
                    </div>
                </div>
            </div>

            <div class="col-6 form-group checkbox-block">
                <label class="label" for="form-check-input"> {{ 'DIALOG.TAG_LIST.DISPLAY_TEXT_MARK' | translate }}?</label>
                <div class="checkbox">
                    <!-- <input type="checkbox" formControlName="text_visible"> -->
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" name="text_visible"
                            id="text_visible" formControlName="text_visible">
                        <label class="custom-control-label" for="text_visible"></label>
                    </div>
                </div>
            </div>

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm btn-custom-actions"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
    <button *ngIf="!tagId" type="button" class="btn btn-primary btn-sm btn-custom-actions" (click)="onCreate()"   [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="tagId"  type="button" class="btn btn-primary btn-sm btn-custom-actions" (click)="onUpdate()"   [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
</div>